import React from 'react';

/* Heading */
const MainHeading = ({ mainHeading, classes = 'text-xl text-gray-900 leading-6' }) => {
  return <h3 className={'mb-0 font-semibold ' + (classes) }>{mainHeading}</h3>;
};

export default MainHeading;
